import {Baseline} from '../message/Baseline';
import {BaselineValue} from '../message/BaselineValue';

export class BaselineUpdatePack {
createLines: {[key: string]: Baseline};
createValues: BaselineValue[];
deleteLines: {[key: string]: Baseline};
deleteValues: BaselineValue[];
updateLines: {[key: string]: Baseline};
updateValues: BaselineValue[];
}

